
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PostponeCloseCause')
export class PostponeCloseCause {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('cause', String, true)
    cause = '';

    @JsonProperty('cause_ar', String, true)
    causeAr = '';

    get causeStr() {
        return this.causeAr || this.cause;
    }
}